import { Route, Switch } from "react-router";
import FaultCodesTable from "./FaultCodesTable";

export default () => (
  <Switch>
    <Route exact path="/faultcodes" component={FaultCodesTable} />
  </Switch>
);
